import { LoaderMask } from 'components/LoaderMask/LoaderMask';
import { useAsyncEffect } from 'customHooks/hooks';
import React, { ReactElement, useContext } from 'react';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import { getDemographicsScoreData } from 'screens/WidgetGenerator/helpers/demographicsScore';
import { ReportBuilderComponentProps } from 'screens/WidgetGenerator/reportGeneratorComponents/components/WidgetWrappers/WidgetWrappers';
import { SurveysReportGeneratorFilterKey } from 'screens/WidgetGenerator/reportGeneratorComponents/enums';
import { DemographicsTable } from 'screens/WidgetGenerator/widgets/DemographicsTable/DemographicsTable';
import { logger } from 'utils/logger';

export const DemographicsTableHOC = (props: ReportBuilderComponentProps): ReactElement => {
  const { client, cycles, selectedDateRange } = useContext(WidgetGeneratorContext);

  const { params } = props;
  const { filters } = params;

  const fetchDemographicsData = async () => {
    const fetchedDemographicsData = await getDemographicsScoreData(client, cycles, selectedDateRange);
    return fetchedDemographicsData;
  };

  const {
    fetchedData: demographicsData,
    isLoading,
    error,
  } = useAsyncEffect(fetchDemographicsData, [client, cycles, selectedDateRange]);
  if (error) {
    logger.error(error);
  }

  return (
    <LoaderMask isLoading={isLoading}>
      <DemographicsTable
        widgetData={demographicsData ?? []}
        numRowsPerTable={filters?.[SurveysReportGeneratorFilterKey.DEMOGRAPHICS_TABLE_ROWS_PER_TABLE]}
      />
    </LoaderMask>
  );
};
